export default "__VITE_PUBLIC_ASSET__ed2fa53e__"